.tag-content {
  align-items: center;
}
